function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}


(function ($) {

$(document).ready(function(){
  $("#pickupLink").click(function(){
   window.location.href="/collections/hot-pizza";
   
  });
  $("#deliveryLink").click(function(){
    $(".pickMsg").hide();
    $("#pickup-form").removeClass("showForm");
    $("#delivery-form").addClass("showForm");
    $(".continuePickup").hide();
   //window.location.href="/collections/shop";
  });
  
  $("#changeTimeSlot").change(function(){
    var selectedTime = $('#changeTimeSlot :selected').text();
    $("#pickup-time").val(selectedTime);
    $(".continuePickup").show();
  });
  
  $(".continuePickup").click(function(){
    window.location.href="/collections/pizza";
  });
});
  }(jQuery.noConflict()));